import React, { Fragment, useEffect, useState } from 'react';
import { RootState } from 'ReduxStore/store';
import { Redirect, Route, useHistory, withRouter, Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { GetAllExercises, GetExerciseById } from 'ReduxStore/exercises/Action';
import { useStyles } from './exercise.style';
import category from 'Assets/img/svg/categoriesImage.svg';
import Header from 'Components/Header/Header';
import { categories } from 'Utils/options';
import MenuCard from 'Components/Reusable/Menu/MenuCard';
import Background from 'Components/Reusable/Background/Background';
import OverlapCard from 'Components/Reusable/Cards/OverlapCard';
import backButton from 'Assets/img/svg/buttons/back.svg';
import { BackButton, CommonButton } from 'Components/Reusable/Buttons/Buttons';
import { getMilestoneById } from 'ReduxStore/milestones/Action';
import {  useParams } from 'react-router-dom';
import { changeIdentities, getMilestoneImage } from 'Helpers';
import useMediaQuery from '@material-ui/core/useMediaQuery';


import fineMotorIcon from 'Assets/img/svg/Backgrounds/fineMotor/fineMotorIcon.svg';
import cognitiveIcon from 'Assets/img/svg/Backgrounds/cognitive/cognitiveIcon.svg';
import communicationIcon from 'Assets/img/svg/Backgrounds/communication/communicationIcon.svg';
import grossMotorIcon from 'Assets/img/svg/Backgrounds/grossMotor/grossMotorIcon.svg';
import sensoryIcon from 'Assets/img/svg/Backgrounds/sensory/sensoryIcon.svg';

import fineMotorTopIcon from 'Assets/img/svg/Backgrounds/fineMotor/topIcon.svg';
import cognitiveTopIcon from 'Assets/img/svg/Backgrounds/cognitive/topIcon.svg';
import communicationTopIcon from 'Assets/img/svg/Backgrounds/communication/topIcon.svg';
import grossMotorTopIcon from 'Assets/img/svg/Backgrounds/grossMotor/topIcon.svg';
import sensoryIconTopIcon from 'Assets/img/svg/Backgrounds/sensory/topIcon.svg';


import socialEmotionalIcon from 'Assets/img/svg/Backgrounds/socialEmotional/socialEmotionalIcon.svg';
import CustomModal from 'Components/Modals/CustomModal';
import Archived from 'Components/milestones/Archived';
import { GetAllKids } from 'ReduxStore/children/Action';

interface RouteParams {
	id: string;
	categoryId:string;
}
const ListExercise = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const childName = localStorage.getItem('currentChild')
	const params = useParams<RouteParams>();
	const history= useHistory()
	const milestoneId= params.id
	const matches = useMediaQuery('(max-width:550px)');
	const [open,setOpen] = useState(false);
	const handleOpen = (id:number) => {
		setOpen(true)
	};
	const handleClose = () => {
		setOpen(false);
	};
	useEffect(() => {
		dispatch(getMilestoneById(milestoneId));
		dispatch(GetAllKids());
	}, []);
	const milestone = useSelector((state:RootState) => state.milestones.milestoneItem);
	const children = useSelector((state: RootState) => state.children.children);
	const getChildId = JSON.parse(localStorage.getItem('currentChildId') || '{}');
	const child = children && children.find(child => child.id === parseInt(getChildId));

	const handleClick = () => {
		setOpen(true)
	}
	
	const milestoneTitle = milestone && milestone?.DevelopmentCategory?.title
	const imageValue = milestoneTitle  === "Gross motor skills" ? grossMotorTopIcon : fineMotorTopIcon
	const achievedValue = milestone && milestone?.MilestoneAchieveds && milestone?.MilestoneAchieveds?.length > 0 
	const onClick = (id: any ) => {
		return history.push(`/exercise/${id}`)
	}
	const images = getMilestoneImage(milestoneTitle,matches)
	// eslint-disable-next-line no-console
	console.log(milestoneTitle)
	// eslint-disable-next-line no-console
	console.log(images)
	return (
		<Fragment>

			<Background backgroundColor="#FDEF6D" height={matches ? '100vh' : '100vh'}  >
			<BackButton image={backButton} transparent />
				<OverlapCard
					heading={milestone && changeIdentities(milestone?.title,childName,child?.gender) }
					information={milestone && changeIdentities(milestone?.description,child?.fullName,child?.gender)}
					common={{ margin: '-3rem auto 2rem', width: '80%' }}
					image={ open ? '' : images}
					upper
					rounded
					buttonText="SAVE MILESTONE"
					onClick={handleClick}
					achieved={achievedValue}
				>
					{open &&  (
						<CustomModal open={handleOpen} handleClose={handleClose}>
							<Archived milestoneCategoryId={params.categoryId}  id={milestone?.id} open={open} setOpen={() => handleClose()}/>
						</CustomModal>
					) }
					{
						milestone && milestone?.Exercise?.id ? (
							<div className="d-flex justify-content-center flex-column align-items-center">
							<CommonButton
							onClick={ () =>  onClick(milestone && milestone?.Exercise?.id) }
							command={ "CHECK OUT EXERCISE"}
							common={{
								width: 'inherit',
								height: '48px',
								background: `${'white'}`,
								radius: '200px',
								margin: '2rem 0',
								color: '#78393D',
							}}
						/>
						</div>
						) : ''
					}					
				</OverlapCard>
			</Background>	
		</Fragment>
	);
};
export default ListExercise;
